<template>
    <bs5-base-modal title="Set New Password" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="setPassword">
                <div class="mb-3">
                    <bs5-base-label for="newPassword" class="form-label">New Password</bs5-base-label>
                    <bs5-base-input v-model="password.newPassword" type="password" id="newPassword" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="confirmPassword">Confirm Password</bs5-base-label>
                    <bs5-base-input v-model="password.confirmNewPassword" type="password" id="confirmPassword"
                        required />
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button @click="closeModal" />
            <bs5-save-button :loading="saving" @click="setPassword" />
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import userService from "@/services/user.service";
import { showToast } from "@/utils/toast";
export default defineComponent({
    name: "SetPasswordModal",
    props: {
        visible: { type: Boolean, required: true },
        userId: { type: String, required: true },
    },
    emits: ["close", "password-set"],
    data() {
        return {
            password: ref({
                newPassword: "",
                confirmNewPassword: "",
            }),
            saving: ref(false),
        };
    },
    methods: {
        async setPassword() {
            if (this.password.newPassword !== this.password.confirmNewPassword) {
                alert("Passwords do not match!");
                return;
            }

            this.saving = true;
            try {
                await userService.setPassword(this.userId, this.password.newPassword, this.password.confirmNewPassword);
                this.$emit("password-set");
                this.closeModal();
                showToast("Password changed successfully!", "success");
            } catch (error) {
                showToast("Failed to change password", "error");
                console.error("Error setting password:", error);
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>